// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tbody>tr[data-v-45d87748]:hover{background-color:rgb(34 127 97 / 0.3);--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity))}td[data-v-45d87748]{padding:0.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
